export const hospitalFeatureList=[
    {
      title: "Swift Expert Consultations:",
      description:
        "Quick access to specialized expertise whenever needed. No delays! No specialist manhunt!",
    },
    {
      title: "Simplified Processes:",
      description: "Streamlined monitoring, billing, and payment processes.",
    },
    {
      title: "Enhanced Patient Care:",
      description:
        "Improved patient outcomes through timely and accurate specialist opinions.",
    },
  ];
  export const specialistsFeatureList = [
    {
      title: "Flexible Work Opportunities:",
      description:
        "Opportunity to take on additional consultations on a flexible basis.",
    },
    {
      title: "Simplified Payment Processes:",
      description: "Hassle-free payment and billing.",
    },
    {
      title: "Increased Visibility:",
      description:
        "Enhanced professional visibility and networking opportunities.",
    },
    {
      title: "Reduced Travel and Time:",
      description:
        "Virtual consultations can eliminate the need for physical visits, saving time and effort.",
    },
  ];

  export const patientsFeatureList = [
    {
      title: "Faster Access to Specialized Care:",
      description:
        "Patients are quickly connected with the right specialist, reducing wait times for consultations.",
    },
    {
      title: "Improved Diagnostic Accuracy:",
      description:
        "Access to expert opinions can lead to more accurate diagnoses and treatment plans.",
    },
    {
      title: "Enhanced Patient Experience:",
      description:
        "A streamlined process for scheduling appointments and receiving consultations.",
    },
    {
      title: "Reduced Travel and Time:",
      description:
        "Virtual consultations can eliminate the need for physical visits, saving time and effort.",
    },
    {
      title: "Consistent Quality Care:",
      description:
        "Access to a network of verified and experienced specialists.",
    },
  ];